(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';

  function trapFocus(container, onEscape) {
    var previous = document.activeElement;
    var nodes = container.querySelectorAll(FOCUSABLE);
    if (nodes.length) nodes[0].focus();

    function onKey(e) {
      if (e.key === 'Escape') { onEscape(); return; }
      if (e.key !== 'Tab') return;
      var list = container.querySelectorAll(FOCUSABLE);
      if (!list.length) return;
      var first = list[0];
      var last = list[list.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    container.addEventListener('keydown', onKey);
    return function release() {
      container.removeEventListener('keydown', onKey);
      if (previous && previous.focus) previous.focus();
    };
  }

  var menu = document.querySelector('[data-mobile-menu]');
  var releaseMenu = null;

  function setMenu(open) {
    if (!menu) return;
    menu.setAttribute('data-open', open ? 'true' : 'false');
    document.body.style.overflow = open ? 'hidden' : '';
    var toggle = document.querySelector('[data-menu-open]');
    if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) { releaseMenu = trapFocus(menu, function () { setMenu(false); }); }
    else if (releaseMenu) { releaseMenu(); releaseMenu = null; }
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-menu-open]')) { e.preventDefault(); setMenu(true); }
    if (e.target.closest('[data-menu-close]')) { e.preventDefault(); setMenu(false); }
  });

  var drawer = document.querySelector('[data-cart-drawer]');
  var releaseDrawer = null;

  function setDrawer(open) {
    if (!drawer) return;
    drawer.setAttribute('data-open', open ? 'true' : 'false');
    document.body.style.overflow = open ? 'hidden' : '';
    if (open) { releaseDrawer = trapFocus(drawer, function () { setDrawer(false); }); }
    else if (releaseDrawer) { releaseDrawer(); releaseDrawer = null; }
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); setDrawer(true); refreshCart(); }
    if (e.target.closest('[data-cart-close]') || e.target.closest('[data-drawer-scrim]')) {
      e.preventDefault();
      setDrawer(false);
    }
  });

  function refreshCart() {
    if (!drawer) return;
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + '?section_id=cart-drawer' : '/?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.querySelector('[data-cart-contents]');
        var current = drawer.querySelector('[data-cart-contents]');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
      })
      .catch(function () { });
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form.kf-product-form');
    if (!form) return;
    e.preventDefault();

    var button = form.querySelector('[data-add-button]');
    var mobileButton = document.querySelector('[data-mobile-atc-button]');
    var original = button ? button.textContent : '';
    var mobileOriginal = mobileButton ? mobileButton.textContent : '';

    function setBoth(text, disabled) {
      if (button) {
        button.textContent = text;
        if (disabled) button.setAttribute('aria-disabled', 'true'); else button.removeAttribute('aria-disabled');
      }
      if (mobileButton) {
        mobileButton.textContent = text;
        mobileButton.disabled = !!disabled;
      }
    }

    setBoth((button && button.dataset.adding) || 'Adding', true);

    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body.description || 'Add to cart failed');
        setBoth((button && button.dataset.added) || 'Added to cart', true);
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        refreshCart();
        setDrawer(true);
        setTimeout(function () {
          setBoth(original, false);
          if (mobileButton) mobileButton.textContent = mobileOriginal;
        }, 1400);
      })
      .catch(function (err) {
        setBoth(original, false);
        if (mobileButton) mobileButton.textContent = mobileOriginal;
        var slot = form.querySelector('[data-form-error]');
        if (slot) { slot.textContent = err.message; slot.hidden = false; }
      });
  });

  var mobileAtc = document.querySelector('[data-mobile-atc]');
  var mainAddButton = document.querySelector('[data-add-button]');
  if (mobileAtc && mainAddButton && 'IntersectionObserver' in window) {
    var atcObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        mobileAtc.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { rootMargin: '0px 0px -35% 0px' });
    atcObserver.observe(mainAddButton);
  }

  document.addEventListener('click', function (e) {
    var atcBtn = e.target.closest('[data-mobile-atc-button]');
    if (!atcBtn || atcBtn.disabled) return;
    var form = document.querySelector('form.kf-product-form');
    if (!form) return;
    if (form.requestSubmit) form.requestSubmit();
    else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
  });

  document.addEventListener('click', function (e) {
    var remove = e.target.closest('[data-cart-remove]');
    if (!remove) return;
    e.preventDefault();
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: remove.dataset.cartRemove, quantity: 0 })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); refreshCart(); });
  });

  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]');
    if (!step) return;
    var wrap = step.closest('[data-qty]');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var next = parseInt(input.value, 10) + parseInt(step.dataset.qtyStep, 10);
    input.value = Math.max(1, isNaN(next) ? 1 : next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-gallery-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('[data-gallery]');
    var main = gallery && gallery.querySelector('[data-gallery-main]');
    if (!main) return;

    var thumbsList = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));
    var index = thumbsList.indexOf(thumb);

    thumbsList.forEach(function (t) {
      t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
    });
    main.src = thumb.dataset.full || thumb.querySelector('img').src;
    main.alt = thumb.dataset.alt || '';

    var dots = gallery.querySelectorAll('[data-gallery-dots] .kf-gallery__dot');
    dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });

    if (thumb.scrollIntoView) {
      thumb.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', inline: 'center', block: 'nearest' });
    }
  });

  function stepGallery(direction) {
    var gallery = document.querySelector('[data-gallery]');
    if (!gallery) return;
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));
    if (thumbs.length < 2) return;
    var current = thumbs.findIndex(function (t) { return t.getAttribute('aria-current') === 'true'; });
    if (current === -1) current = 0;
    var next = (current + direction + thumbs.length) % thumbs.length;
    thumbs[next].click();
  }

  var swipeTarget = document.querySelector('[data-swipe-target]');
  if (swipeTarget) {
    var touchStartX = 0;
    var touchStartY = 0;
    var isTracking = false;

    swipeTarget.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      isTracking = true;
    }, { passive: true });

    swipeTarget.addEventListener('touchend', function (e) {
      if (!isTracking) return;
      isTracking = false;
      var touch = e.changedTouches[0];
      var dx = touch.clientX - touchStartX;
      var dy = touch.clientY - touchStartY;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
      stepGallery(dx < 0 ? 1 : -1);
    }, { passive: true });
  }

  /* --- Thumbnail-Leiste: "mehr als 4 Bilder" Pfeil + Weichzeichner --------- */
  (function () {
    var thumbs = document.querySelector('[data-gallery-thumbs]');
    if (!thumbs) return;
    var nav = document.querySelector('[data-thumbs-next]');
    if (!nav) return;

    function update() {
      // Wie weit kann noch nach rechts gescrollt werden?
      var maxScroll = thumbs.scrollWidth - thumbs.clientWidth;
      var remaining = maxScroll - thumbs.scrollLeft;
      // Wenn noch mehr als ein paar Pixel uebrig sind -> Pfeil + Weichzeichner an
      if (remaining > 8) {
        thumbs.classList.add('has-more');
        nav.hidden = false;
      } else {
        thumbs.classList.remove('has-more');
        nav.hidden = true;
      }
    }

    nav.addEventListener('click', function () {
      // Um die sichtbare Breite (ca. 4 Bilder) weiterscrollen
      thumbs.scrollBy({ left: thumbs.clientWidth * 0.8, behavior: reduceMotion ? 'auto' : 'smooth' });
    });

    thumbs.addEventListener('scroll', function () {
      window.requestAnimationFrame(update);
    }, { passive: true });

    window.addEventListener('resize', update);
    // initial nach dem Laden pruefen
    if (document.readyState === 'complete') update();
    else window.addEventListener('load', update);
    setTimeout(update, 300);
  })();

  document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
    var form = picker.closest('form.kf-product-form') || document.querySelector('form.kf-product-form');
    var idInput = form && form.querySelector('[data-variant-id]');

    picker.addEventListener('click', function (e) {
      var option = e.target.closest('[data-variant-option]');
      if (!option) return;

      picker.querySelectorAll('[data-variant-option]').forEach(function (o) {
        o.setAttribute('aria-checked', o === option ? 'true' : 'false');
      });

      var label = picker.querySelector('[data-variant-label]');
      if (label) label.textContent = option.dataset.variantTitle || '';
      if (idInput) idInput.value = option.dataset.variantOption;

      var price = option.dataset.variantPrice;
      if (price) {
     document.querySelectorAll('[data-variant-price]:not([data-variant-option])').forEach(function (el) { el.textContent = price; });
      }

      var image = option.dataset.variantImage;
      var main = document.querySelector('[data-gallery-main]');
      if (image && main) main.src = image;

      var available = option.dataset.variantAvailable === 'true';
      var button = form && form.querySelector('[data-add-button]');
      var mobileBtn = document.querySelector('[data-mobile-atc-button]');
      [button, mobileBtn].forEach(function (btn) {
        if (!btn) return;
        btn.disabled = !available;
        btn.textContent = available
          ? (btn.dataset.label || btn.textContent)
          : (btn.dataset.soldOut || 'Sold out');
      });
    });
  });

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var end = Date.parse(el.dataset.countdown);
    if (isNaN(end)) { el.closest('[data-offer]') && el.closest('[data-offer]').remove(); return; }

    var cells = {
      days: el.querySelector('[data-cd-days]'),
      hours: el.querySelector('[data-cd-hours]'),
      mins: el.querySelector('[data-cd-mins]'),
      secs: el.querySelector('[data-cd-secs]')
    };

    function tick() {
      var left = end - Date.now();
      if (left <= 0) {
        var panel = el.closest('[data-offer]');
        if (panel) panel.remove(); else el.remove();
        clearInterval(timer);
        return;
      }
      var s = Math.floor(left / 1000);
      if (cells.days) cells.days.textContent = pad(Math.floor(s / 86400));
      if (cells.hours) cells.hours.textContent = pad(Math.floor(s % 86400 / 3600));
      if (cells.mins) cells.mins.textContent = pad(Math.floor(s % 3600 / 60));
      if (cells.secs) cells.secs.textContent = pad(s % 60);
    }

    tick();
    var timer = setInterval(tick, 1000);
  });

  var sticky = document.querySelector('[data-sticky-offer]');
  if (sticky) {
    var key = 'kf-offer-dismissed-' + (sticky.dataset.stickyOffer || 'default');
    if (sessionStorage.getItem(key) !== '1') {
      setTimeout(function () { sticky.setAttribute('data-visible', 'true'); }, reduceMotion ? 0 : 1200);
    }
    sticky.addEventListener('click', function (e) {
      if (e.target.closest('[data-offer-dismiss]')) {
        sticky.setAttribute('data-visible', 'false');
        sessionStorage.setItem(key, '1');
      }
      var copy = e.target.closest('[data-copy-code]');
      if (copy && navigator.clipboard) {
        navigator.clipboard.writeText(copy.dataset.copyCode).then(function () {
          var was = copy.textContent;
          copy.textContent = copy.dataset.copied || 'Copied';
          setTimeout(function () { copy.textContent = was; }, 1600);
        });
      }
    });
  }

  var revealables = document.querySelectorAll('[data-reveal]');
  if (revealables.length && !reduceMotion && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var delay = parseInt(entry.target.dataset.revealDelay || '0', 10);
        setTimeout(function () { entry.target.classList.add('is-visible'); }, delay);
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -60px 0px', threshold: 0.05 });

    revealables.forEach(function (el, i) {
      var siblings = el.parentElement ? el.parentElement.querySelectorAll(':scope > [data-reveal]') : [];
      var index = Array.prototype.indexOf.call(siblings, el);
      el.dataset.revealDelay = String(Math.max(0, index) * 60);
      observer.observe(el);
    });
  } else {
    revealables.forEach(function (el) { el.classList.add('is-visible'); });
  }

  var sort = document.querySelector('[data-sort]');
  if (sort) {
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  var track = document.querySelector('[data-announcement-track]');
  if (track && !reduceMotion) {
    var mq = window.matchMedia('(max-width: 900px)');
    var cloned = false;
    function syncMarquee() {
      if (mq.matches && !cloned) {
        track.innerHTML += track.innerHTML;
        cloned = true;
      }
    }
    syncMarquee();
    if (mq.addEventListener) mq.addEventListener('change', syncMarquee);
  }
})();
